<div class="horizontal-select category-select-container">
	<span class="label">{{ 'category' | translate }}</span>
	<p [matMenuTriggerFor]="categoryList">
		{{
			formControl.value
				? (categories.itemMap.get(formControl.value) | translate)
				: ('none' | translate)
		}}
	</p>
</div>

<mat-menu #categoryList class="au-cmms-select-dropdown">
	<ul class="categories-list-menu">
		@for (category of entityCategories; track category) {
			<li
				class="category-list-item"
				(click)="selectCategory(category.key)"
				[class.active]="category.key === formControl.value"
			>
				<p>{{ category.translatedValue }}</p>
			</li>
		}
	</ul>
</mat-menu>
